(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kaya-restock-request"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kaya-restock-request')) {
  customElements.define('kaya-restock-request', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.select = this.querySelector('[data-restock-variant]');
      this.onHash = () => {
        if (window.location.hash === '#' + this.details.id) this.details.open = true;
      };
      this.onHash();
      window.addEventListener('hashchange', this.onHash);
      this.start = () => {
        if (this.unsubscribe || typeof window.subscribe !== 'function') return;
        this.unsubscribe = window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, ({data}) => {
          if (String(data.sectionId) !== this.dataset.sectionId) return;
          const variant = data.variant;
          this.classList.toggle('kaya-restock--selected', Boolean(variant && !variant.available));
          if (!variant || variant.available || !this.select) return;
          const match = Array.from(this.select.options).find(option => option.dataset.variantId === String(variant.id));
          if (match) this.select.value = match.value;
        });
      };
      this.start();
      document.addEventListener('DOMContentLoaded', this.start, {once:true});
      this.onOpen = () => {
        if (this.details.open && this.select?.hidden) this.querySelector('input[type=email]')?.focus({preventScroll:true});
      };
      this.details.addEventListener('toggle', this.onOpen);
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      window.removeEventListener('hashchange', this.onHash);
      document.removeEventListener('DOMContentLoaded', this.start);
      this.details?.removeEventListener('toggle', this.onOpen);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
